var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBudget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0C3.14038 0 0 3.14038 0 7C0 10.8596 3.14038 14 7 14C10.8596 14 14 10.8596 14 7C14 3.14038 10.8596 0 7 0ZM7 13.125C3.6225 13.125 0.875 10.3775 0.875 7C0.875 3.6225 3.6225 0.875 7 0.875C10.3775 0.875 13.125 3.6225 13.125 7C13.125 10.3775 10.3775 13.125 7 13.125Z",
    fill: "#252525",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50325 9.28987C8.17775 9.51212 7.819 9.625 7.4375 9.625C6.63162 9.625 5.93338 9.093 5.5545 8.3125H7C7.2415 8.3125 7.4375 8.1165 7.4375 7.875C7.4375 7.6335 7.2415 7.4375 7 7.4375H5.28675C5.26662 7.29487 5.25 7.14963 5.25 7C5.25 6.85037 5.26662 6.70513 5.28675 6.5625H7.4375C7.679 6.5625 7.875 6.3665 7.875 6.125C7.875 5.8835 7.679 5.6875 7.4375 5.6875H5.5545C5.93338 4.907 6.63162 4.375 7.4375 4.375C7.819 4.375 8.17775 4.48787 8.50325 4.71012C8.70275 4.84575 8.97575 4.79587 9.11137 4.5955C9.24788 4.396 9.19625 4.12388 8.99675 3.98738C8.5295 3.66888 7.9905 3.5 7.4375 3.5C6.15562 3.5 5.05838 4.40737 4.6025 5.6875H3.9375C3.696 5.6875 3.5 5.8835 3.5 6.125C3.5 6.3665 3.696 6.5625 3.9375 6.5625H4.4135C4.39775 6.70775 4.375 6.85037 4.375 7C4.375 7.14963 4.39775 7.29225 4.4135 7.4375H3.9375C3.696 7.4375 3.5 7.6335 3.5 7.875C3.5 8.1165 3.696 8.3125 3.9375 8.3125H4.6025C5.05838 9.59263 6.15562 10.5 7.4375 10.5C7.9905 10.5 8.5295 10.3311 8.99675 10.0126C9.19625 9.87612 9.24788 9.604 9.11137 9.4045C8.97575 9.205 8.70275 9.15425 8.50325 9.28987Z",
    fill: "#252525",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBudget);
export default __webpack_public_path__ + "static/media/budget.9a8682038f3795ef6b5bfa9083b85441.svg";
export { ForwardRef as ReactComponent };